module.exports = __webpack_public_path__ + "img/download.f60040e.svg";